<template>

    <v-container>
        <div class="text-xs-center">
            <v-alert :value="alertFlag" class="rounded-alert" outline type="info">
                Εμφανίζονται τα πρώτα 5 αποτελέσματα.
                Αν το σύγγραμμα που αναζητείτε δεν υπάρχει, δοκιμάστε με αναλυτικότερα πεδία αλλιώς
                πατήστε <a class="warning--text" href="https://service.eudoxus.gr/search" target="_blank">εδώ</a>
                για καλύτερη αναζήτηση.
                Αφού βρείτε το σωστό σύγγραμμα, εισάγετε τον "Κωδικό στον Εύδοξο" για να το αναζητήσετε.
            </v-alert>
        </div>

        <v-card hover>
            <v-layout align-center class="pa-2" id="searchPlace">

                <v-text-field
                        class="ml-3"
                        clearable
                        label="Κωδικός στον Εύδοξο"
                        required
                        v-model="id"></v-text-field>

                <v-text-field
                        class="ml-3"
                        clearable
                        label="Τίτλος"
                        required
                        v-model="bookTitle"></v-text-field>

                <v-text-field
                        class="ml-3"
                        clearable
                        label="Συγγραφείς"
                        required
                        v-model="bookAuthor"></v-text-field>

                <v-tooltip top>
                    <v-btn @click="searchBooksForExchange"
                           class="ml-5 mr-4"
                           color="primary"
                           round
                           slot="activator">
                        <span class="editButton">Αναζήτηση</span>
                        <v-icon>search</v-icon>
                    </v-btn>
                    <span>Συμπληρώστε κάποιο από τα 3 πεδία για αναζήτηση συγγραμμάτων</span>
                </v-tooltip>
            </v-layout>
        </v-card>
        <br>

        <v-data-table
                :headers="headers"
                :items="$store.getters.solarResponse"
                :loading="loading"
                :pagination.sync="pagination"
                class="elevation-6"
                hide-actions>
            <v-progress-linear color="primary" indeterminate slot="progress"></v-progress-linear>
            <template slot="items" slot-scope="props">
                <!--<td>{{ props.item.state }}</td>-->
                <!--<td>{{ props.item.id }}</td>-->
                <td class="text-xs-start"><v-icon left>library_books</v-icon><a @click="openDialog(props.item)">
                    <u>
                    {{[props.item.id]}} {{props.item.title}}, {{props.item.authors}}, {{props.item.publicationYear}}
                    , {{props.item.editorialHouse}} ISBN: {{props.item.isbn}} </u></a></td>
                <td class="right">
                    <v-flex sm3>
                        <v-btn @click="addBookToExchange(props.item.id)"
                               color="info"
                               round>
                            <span class="editButton">Προσθήκη</span>
                            <v-icon>add</v-icon>
                        </v-btn>
                    </v-flex>
                </td>
            </template>
        </v-data-table>
        <v-snackbar :multi-line="mode === 'multi-line'" :timeout="timeout"
                    bottom
                    color="warning"
                    v-model="snackbar"
                    :vertical="mode === 'vertical'">Το βιβλίο καταχωρήθηκε επιτυχώς
        </v-snackbar>
    </v-container>
</template>

<script>

    import request from '../../requests';
    import util from '../../utilities';
    import {GlobalEudoxusBus} from  '../../main';

    export default {
        name: "NonEudoxusExchangeComponent",
        data() {
            return {
                mode: '',
                alertFlag: false,
                timeout: 6000,
                snackbar: false,
                id: '',
                bookTitle: '',
                bookAuthor: '',
                loading: false,
                pagination: {},
                headers: [
                    // {
                    //     text: 'ID',
                    //     align: 'left',
                    //     value: 'name'
                    // },
                    {text: 'Σύγγραμμα', align: 'left', value: 'calories', sortable: false},
                    {text: 'Επιλογές', class: 'right mr-5 my-3', align: 'right', sortable: false}
                ],
                desserts: [
                    {
                        state: '0',
                        value: false,
                        name: '[86] "Ψηφιακή Επεξεργασία και Ανάλυση Εικόνας"Σύγγραμμα, Παπαμάρκος Νικόλαος, 2010, Αυοέκδοση, ISBN: 978-960-92731-3-8',
                        calories: 'Έχετε παραλάβει το βιβλίο. Μπορείτε να το διαθέσετε για ανταλλαγή. Με την παράδοση του βιβλίου θα προστεθούν μονάδες πίστωσης στον λογαριασμό σας.'

                    },
                    {
                        state: '0',
                        value: false,
                        name: '[12304] "Επικοινωνία ανθρώπου - υπολογιστή, 3ή Έκδοση"Σύγγραμμα, Dix Alan J.,Finla',
                        calories: 'Έχετε παραλάβει το βιβλίο. Μπορείτε να το διαθέσετε για ανταλλαγή. Με την παράδοση του βιβλίου θα προστεθούν μονάδες πίστωσης στον λογαριασμό σας.'

                    },
                    {
                        state: '0',
                        value: false,
                        name: '[86] "Ψηφιακή Επεξεργασία και Ανάλυση Εικόνας"Σύγγραμμα, Παπαμάρκος Νικόλαος, 2010, Αυοέκδοση, ISBN: 978-960-92731-3-8',
                        calories: 'Έχετε παραλάβει το βιβλίο. Μπορείτε να το διαθέσετε για ανταλλαγή. Με την παράδοση του βιβλίου θα προστεθούν 5,42 μονάδες πίστωση στον λογαριασμό σας.'
                    },
                    {
                        state: '0',
                        value: false,
                        name: '[24749] "Εφαρμοσμένη μιγαδική ανάλυση"Σύγγραμμα, Κραββαρίτης Δ ., 2006, Συμεών, ISBN: 960-7888-65-0',
                        calories: 'Έχετε παραλάβει το βιβλίο. Μπορείτε να το διαθέσετε για ανταλλαγή. Με την παράδοση του βιβλίου θα προστεθούν 5,42 μονάδες πίστωση στον λογαριασμό σας.'

                    },
                    {
                        state: '0',
                        value: false,
                        name: '[13954] "ΔΙΚΤΥΑ ΥΠΟΛΟΓΙΣΤΩΝ: ΜΙΑ ΠΡΟΣΕΓΓΙΣΗ ΑΠΟ ΤΗ ΣΚΟΠΙΑ ΤΩΝ ΣΥΣΤΗΜΑΤΩΝ"Σύγγραμμα, LARRY L. PETERSON, BRUCE S. DAVI-6',
                        calories: 'Έχετε παραλάβει το βιβλίο. Μπορείτε να το διαθέσετε για ανταλλαγή. Με την παράδοση του βιβλίου θα προστεθούν 5,42 μονάδες πίστωση στον λογαριασμό σας.'

                    },
                    {
                        state: '0',
                        value: false,
                        name: '[86] "Ψηφιακή Επεξεργασία και Ανάλυση Εικόνας"Σύγγραμμα, Παπαμάρκος Νικόλαος, 2010, Αυοέκδοση, ISBN: 978-960-92731-3-8',
                        calories: 'Έχετε παραλάβει το βιβλίο. Μπορείτε να το διαθέσετε για ανταλλαγή. Με την παράδοση του βιβλίου θα προστεθούν μονάδες πίστωσης στον λογαριασμό σας.'
                    },
                    {
                        state: '0',
                        value: false,
                        name: '[86] "Ψηφιακή Επεξεργασία και Ανάλυση Εικόνας"Σύγγραμμα, Παπαμάρκος Νικόλαος, 2010, Αυοέκδοση, ISBN: 978-960-92731-3-8',
                        calories: 'Έχετε παραλάβει το βιβλίο. Μπορείτε να το διαθέσετε για ανταλλαγή. Με την παράδοση του βιβλίου θα προστεθούν μονάδες πίστωσης στον λογαριασμό σας.'
                    },
                    {
                        state: '0',
                        value: false,
                        name: 'Pie Apple',
                        calories: 'Έχετε παραλάβει το βιβλίο. Μπορείτε να το διαθέσετε για ανταλλαγή. Με την παράδοση του βιβλίου θα προστεθούν μονάδες πίστωσης στον λογαριασμό σας.'
                    },
                    {
                        state: '0',
                        value: false,
                        name: '[13954] "ΔΙΚΤΥΑ ΥΠΟΛΟΓΙΣΤΩΝ: ΜΙΑ ΠΡΟΣΕΓΓΙΣΗ ΑΠΟ ΤΗ ΣΚΟΠΙΑ ΤΩΝ ΣΥΣΤΗΜΑΤΩΝ"Σύγγραμμα, LARRY L. PETERSON, BRUCE S. DAVIE, 2009ΙΔΑΡΙΘΜΟ-6',
                        calories: 'Έχετε παραλάβει το βιβλίο. Μπορείτε να το διαθέσετε για ανταλλαγή. Με την παράδοση του βιβλίου θα προστεθούν 5,42 μονάδες πίστωση στον λογαριασμό σας.'
                    },
                    {
                        state: '0',
                        value: false,
                        name: 'Marshmallow',
                        calories: 'Έχετε παραλάβει το βιβλίο. Μπορείτε να το διαθέσετε για ανταλλαγή. Με την παράδοση του βιβλίου θα προστεθούν 5,42 μονάδες πίστωση στον λογαριασμό σας.'
                    },
                    {
                        state: '0',
                        value: false,
                        name: 'Eclair',
                        calories: 'Έχετε παραλάβει το βιβλίο. Μπορείτε να το διαθέσετε για ανταλλαγή. Με την παράδοση του βιβλίου θα προστεθούν μονάδες πίστωσης στον λογαριασμό σας.'
                    }
                ]
            }
        },
        methods: {

            openDialog(book) {
                this.$store.commit('setBookInfoModal', book);
                this.$store.commit('setDialog', true)
            },

            callBackSuccessExchangeBooks(response) {
                this.$store.commit('setLoadingModal', false);
                this.snackbar = true;
                this.$store.commit('setlistForExchange', response);
                util.setCounterExchangeBooks();
            },

            successAddBookToExchange(response) {
                request.listOfExchangeBooks(this.callBackSuccessExchangeBooks, this.onRequestErrors);
            },

            addBookToExchange(bookid) {
                this.$store.commit('setLoadingModal', true);
                var id = {id: bookid};
                request.addBookToExchange(id, this.successAddBookToExchange)
            },

            successSearchBooksToExchange(response) {
                this.$store.commit('setSolarResponse', response);
                this.$store.commit('setLoadingModal', false);
                this.alertFlag = true;
                this.loading = false;

            },

            searchBooksForExchange() {
                this.$store.commit('setLoadingModal', true);
                this.loading = true;

                if (/\s/.test(this.id)) {
                    // It has any kind of whitespace
                    this.id = this.id.replace(/ /g, "");
                }

                var query = '';

                if (this.id != '' && this.id != null) {
                    query = 'id:' + this.id
                }
                if (this.bookTitle != '' && this.bookTitle != null) {
                    this.bookTitle = this.bookTitle.trim();
                    if (this.id != '' && this.id != null) {
                        query = query.concat(' bookTitle:' + this.bookTitle)
                    } else {
                        query = query.concat('bookTitle:' + this.bookTitle)
                    }
                }
                if (this.bookAuthor != '' && this.bookAuthor != null) {
                    this.bookAuthor = this.bookAuthor.trim();
                    if ((this.id != '' && this.id != null) || (this.bookTitle != '' && this.bookTitle != null)) {
                        query = query.concat(' bookAuthor:' + this.bookAuthor)
                    } else {
                        query = query.concat('bookAuthor:' + this.bookAuthor)
                    }
                }
                request.searchBooksToExchange(query, this.successSearchBooksToExchange);
            },
            initVariables() {
                this.alertFlag = false;
                this.id = '';
                this.bookTitle = '';
                this.bookAuthor = ''
            }
        },
        created() {
            this.$store.commit('setSolarResponse', []);
            this.alertFlag = false;
        },
        computed: {
            pages() {
                if (this.pagination.rowsPerPage == null ||
                    this.pagination.totalItems == null
                ) return 0;

                return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage)
            }
        },
        mounted() {
            GlobalEudoxusBus.$on('initVariables', this.initVariables)
            util.removeDatatableLoadingElement();
        }
    }
</script>

<style scoped>

    /*#searchPlace {*/
    /*margin-top: -3.5em;*/
    /*border: black;*/
    /*}*/

    .editButton {
        font-size: small;
        padding-right: 5px;
    }

</style>
